import { Dialog } from '@headlessui/react';
import { Product } from 'shared/types/product';
import Link from 'next/link';
import ProductTileQuickView from '../../details/components/ProductTileQuickView';
import Close from 'icons/close';

interface Props {
  product: Product;
  isOpen: boolean;
  onClose: () => void;
}
const ProductQuickViewModal = ({ product, isOpen, onClose }: Props) => {
  return (
    <Dialog unmount open={isOpen} onClose={onClose} className="fixed inset-0 z-50 overflow-y-auto bg-gray-600/75">
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <Dialog.Panel className="dark:bg-primary-200 absolute left-1/2 top-1/2 w-[90%] -translate-x-1/2 -translate-y-1/2 bg-white px-4 py-6 sm:px-6 md:w-[989px] lg:px-8">
          <section className="mb-3 flex justify-end">
            <section className="pt-2">
              <button type="button" onClick={onClose}>
                <Close className="fill-sol-300" />
              </button>
            </section>
          </section>
          <div className="customtablescrollbar max-h-[70vh] overflow-y-auto">
            <section className="w-full px-4">
              <section className="mx-auto mb-10 mt-6 max-w-[1440px] lg:mt-1 lg:px-2">
                <ProductTileQuickView
                  key={product.productKey + 'quick view'}
                  product={product}
                  onAddToCart={() => onClose()}
                />
              </section>
            </section>
            <section className="flex justify-center">
              <Link className="text-sol-300 cursor-pointer text-sm leading-10 underline" href={`${product._url}`}>
                View Full Details
              </Link>
            </section>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default ProductQuickViewModal;
